import { Button, Grid, Typography } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";

import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { useGridDefinitions } from "../../../../../controls/ag-grid/components/GridDefinitions";
import { CatalogSampleType } from "../../../models/CatalogSampleType";
import { useGridStyles } from "../../../styles/gridStyles";
import { CreateSampleType } from "./CreateSampleType";
import { EditSampleType } from "./EditSampleType";
import { useTableData } from "./hooks";

type Props = {
	getCatalogSampleTypesFromAPI: Function;
	isLoading: boolean;
};

export const TableSampleType = ({
	getCatalogSampleTypesFromAPI,
	isLoading,
}: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [idSampleType, setIdSampleType] = useState<number | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns, defaultColDef } = useTableData({});
	const { columnTypes } = useGridDefinitions({
		OnEdit: (data: CatalogSampleType) => {
			setShowEditModal(!showEditModal);
			setIdSampleType(data.SampleTypeId);
		},
	});

	const classes = useGridStyles();
	return (
		<>
			<Grid item xs={12} container justifyContent="center" spacing={1}>
				<Grid item md={12} xs={12}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Sample Types
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid item xs={12} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search sample types"
						/>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.SampleTypeId}
								columnTypes={columnTypes}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setIdSampleType(params.data.SampleTypeId);
									setShowEditModal(true);
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid item md={"auto"} xs={12} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW SAMPLE TYPE
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateSampleType
				show={showCreateModal}
				onHide={() => setShowCreateModal(false)}
				refreshData={getCatalogSampleTypesFromAPI}
			/>
			<EditSampleType
				show={showEditModal}
				onHide={(updated: boolean) => {
					setShowEditModal(false);
					setIdSampleType(null);
					if (updated) getCatalogSampleTypesFromAPI();
				}}
				sampleTypeId={idSampleType}
			/>
		</>
	);
};
